import React from "react";
import TeamTitle from "../../components/title/TeamTitle";
import { CardBody, CardContainer, CardFooter, CardHeader } from "best-common-react";
import OrgsAdminFilters from "../../components/orgs/OrgsAdminFilters";
import GlobalProtected from "../../components/protected/GlobalProtected";
import OrgAdminFooter from "../../components/orgs/OrgAdminFooter";
import OrgAddOnBody from "../../components/orgs/OrgAddOnBody";
import LoadingSpinner from "../../components/loading/LoadingSpinner";

function OrgAdminContainer() {
  return (
    <div>
      <TeamTitle />
      <CardContainer>
        <LoadingSpinner size={10} />
        <CardHeader>Orgs</CardHeader>
        <CardBody>
          <OrgsAdminFilters />
          <OrgAddOnBody />
        </CardBody>
        <CardFooter>
          <LoadingSpinner size={10} />
          <OrgAdminFooter />
        </CardFooter>
      </CardContainer>
    </div>
  );
}

export default GlobalProtected(OrgAdminContainer);
